import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <a
        href="https://github.com/Teemah27/weather-app"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open-source code{" "}
      </a>
      by Fatimah
    </div>
  );
}
